import { render, staticRenderFns } from "./WikiPageHistory.vue?vue&type=template&id=739c2e08&scoped=true"
import script from "./WikiPageHistory.vue?vue&type=script&lang=ts"
export * from "./WikiPageHistory.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageHistory.vue?vue&type=style&index=0&id=739c2e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c2e08",
  null
  
)

export default component.exports